import { render, staticRenderFns } from "./TopicsLecturesIndex.vue?vue&type=template&id=628c50e3"
import script from "./TopicsLecturesIndex.vue?vue&type=script&lang=js"
export * from "./TopicsLecturesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports